/**
 * Duck referente a autenticação
 */

import { createActions, createReducer } from "reduxsauce";

//Action types e Creators
export const { Types, Creators } = createActions({
    setRegisterError: [''],
    setRegisterSuccess: ['']
});

//Reducer Handlers
const INITIAL_STATE = {
    registerError: [],
    registerSuccess: []
}

const setRegisterError = (state = INITIAL_STATE, action) => {
    return { 
        ...state, 
        registerError: {
            ...action.payload 
        }
    }
};

const setRegisterSuccess = (state = INITIAL_STATE, action) => {
	return { 
		...state, 
		registerSuccess: {
			...action.payload
		}
	}
}

//Criando Reducer
export default createReducer(INITIAL_STATE, {
    [Types.SET_REGISTER_ERROR]: setRegisterError,
    [Types.SET_REGISTER_SUCCESS]: setRegisterSuccess,
});
